import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import SubscriptionModal from "./SubscriptionModal.layout";

const mapStateToProps = (state) => ({
    subscriptionModal: state.app.subscriptionModal,
});

const mapDispatchToProps = () => ({});

const decorate = compose(
    //
    connect(mapStateToProps, mapDispatchToProps),
);

export default decorate(SubscriptionModal);
